module.exports = __webpack_public_path__ + "img/price-return-shipping.36c2b087.png";